import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowLeft, LineChart } from "lucide-react";
import ec from "@/i18n/ec.json";

export default function ThankYou() {
  useEffect(() => {
    document.documentElement.lang = "es-EC";
    document.title = ec.thank_you.title + " — " + ec.brand.name;
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center">
          <Link to="/" className="flex items-center gap-2 text-slate-900" data-testid="thankyou-logo">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-teal-600 text-white">
              <LineChart className="h-5 w-5" strokeWidth={2.25} />
            </span>
            <span className="font-jakarta text-lg font-bold tracking-tight">{ec.brand.name}</span>
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-16">
        <div className="w-full max-w-xl text-center">
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-teal-100 text-teal-700 mx-auto">
            <CheckCircle2 className="h-9 w-9" strokeWidth={2} />
          </span>
          <p className="mt-6 text-xs font-semibold uppercase tracking-widest text-teal-700">
            {ec.thank_you.eyebrow}
          </p>
          <h1 className="mt-3 font-jakarta text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
            {ec.thank_you.title}
          </h1>
          <p className="mt-5 text-base text-slate-600 leading-relaxed">
            {ec.thank_you.description}
          </p>
          <p className="mt-4 text-sm text-slate-500 leading-relaxed border-l-2 border-teal-500 pl-4 text-left">
            {ec.thank_you.note}
          </p>
          <Link to="/" className="inline-block mt-8" data-testid="thankyou-back-home">
            <Button className="h-11 rounded-md px-6 bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold">
              <ArrowLeft className="h-4 w-4 mr-1" />
              {ec.thank_you.back_home}
            </Button>
          </Link>
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white py-6 text-xs text-slate-500">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          © 2026 {ec.footer.legal.company_name}. RUC {ec.footer.legal.ruc_value}.
        </div>
      </footer>
    </div>
  );
}
